import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import styled from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import { extraLoadChat } from "actions/chat/chat";
import Collapse from "./Collapse";
import eventDispatcher from "views/JobDetailPage/utils/eventDispatcher";
import { EVENT } from "views/JobDetailPage/utils/constants";
import "./styles.scss";

const Body = styled(Scrollbars)`
  grid-area: body;
  height: 100%;
  display: ${(props) => (props.open ? "block" : "none")};
`;

const FilterChat = ({ open, onClose, setTagSelected, tagSelected }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tags = useSelector((state) => state.project.getTagProject.data);
  const members = useSelector((state) => state.taskDetail.taskMember.member);
  const task = useSelector((state) => state.taskDetail.detailTask.taskDetails);

  useEffect(() => {
    if (!open) {
      setTagSelected(null);
    }
  }, [open]);

  useEffect(() => {
    eventDispatcher.dispatch(EVENT.CHANGE_TAG_TASK_FILTER_CHAT, tagSelected);
  }, [tagSelected]);

  const handleSelectTag = (tag, type) => {
    setTagSelected(tag);
    dispatch(extraLoadChat(task?.id, { [type]: tag.id }));
  };

  const handleCancelFilter = () => {
    if (!tagSelected) {
      onClose();
      return;
    }
    dispatch(extraLoadChat(task?.id));
    onClose();
  };

  return (
    <Body
      renderView={(props) => <div {...props} />}
      autoHide
      autoHideTimeout={500}
      autoHideDuration={200}
      open={open}
    >
      <div className="listPart--filterChat">
        <div className="listPart--filterChat--header">
          <span>{t("LABEL_CHAT_TASK_FILTER_TAG")}</span>
          <span
            className="listPart--filterChat--btnClose"
            onClick={handleCancelFilter}
          >
            {t("LABEL_CHAT_TASK_CLOSE")}
          </span>
        </div>
        <Collapse
          classes="listPart--filterChat--tags"
          label={t("LABEL_CHAT_TASK_TAG_TASK")}
        >
          {tags?.map((tag) => (
            <div
              key={tag?.id}
              className={classnames("list-item", {
                "list-item--active": tagSelected?.id === tag?.id,
              })}
              onClick={() => handleSelectTag(tag, "task_tag")}
            >
              #{tag.name}
            </div>
          ))}
        </Collapse>
        <Collapse
          classes="listPart--filterChat--tags"
          label={t("LABEL_CHAT_TASK_TAG_MEMBER")}
        >
          {members?.map((member) => (
            <div
              key={member?.id}
              className={classnames("list-item", {
                "list-item--active": tagSelected?.id === member?.id,
              })}
              onClick={() => handleSelectTag(member, "user_tag")}
            >
              @{member.name}
            </div>
          ))}
        </Collapse>
      </div>
    </Body>
  );
};

export default FilterChat;
